// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Processed object type.
 * @export
 * @enum {string}
 */
export enum RESTJobSessionObjectType {
    Group = 'Group',
    User = 'User',
    Site = 'Site',
    Team = 'Team'
}

